import React from 'react'

const Alert = ({handleOkClick,showAlert,message}) => {
    console.log("the alert component")
  return (
    <div className='fixed top-0 left-0 w-full bg-model flex items-center justify-center overflow-y-hidden h-screen z-[3000]'>
        
        <div
              className="pt-4 custom-gray fixed shadow-md shadow-gray-500 w-3/4 rounded-lg text-center scaleUp"> 
             
              <p className='mb-2 pl-8 pr-8 text-gray-400'>{message}</p>
              <div className="border-solid border-b-2 p-2 w-full border-gray-400"></div>
              <div className='py-2 font-bold bg-blue-500 w-fit px-4 text-white rounded-md  my-2 text-center m-auto hover:opacity-70 cursor-pointer' onClick={handleOkClick}>OK</div>
              {/* <div className='pb-4 pt-4 font-bold text-blue-500 hover:opacity-70 cursor-pointer' onClick={handleOkClick}>OK</div> */}
        </div>
   </div>
  )
}

export default Alert